import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import React from 'react'

export type TurnOffIllustrationKind = 'lock_screen' | 'in_app' | 'feedback'

const ILLUSTRATION_HEIGHT = '106px'
const BADGE_SIZE = '30px'
// Illustration sample text. The en dash is escaped, not raw Unicode in JSX.
const PICKUP_WINDOW = '11:15\u201311:25am'
const THUMB_UP =
  'M7 10V22M15 5.88L14 10H19.83C20.1405 10 20.4467 10.0723 20.7244 10.2111C21.0021 10.35 21.2437 10.5516 21.43 10.8C21.6163 11.0484 21.7422 11.3367 21.7977 11.6422C21.8533 11.9477 21.8369 12.2619 21.75 12.56L19.42 20.56C19.2988 20.9754 19.0462 21.3404 18.7 21.6C18.3538 21.8596 17.9327 22 17.5 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C2 11.4696 2.21071 10.9609 2.58579 10.5858C2.96086 10.2107 3.46957 10 4 10H6.76C7.13208 9.9998 7.49674 9.89581 7.81296 9.69972C8.12917 9.50363 8.38442 9.22321 8.55 8.89L12 2C12.4716 2.00584 12.9357 2.11817 13.3578 2.3286C13.7799 2.53902 14.1489 2.84211 14.4374 3.2152C14.7259 3.5883 14.9263 4.02176 15.0237 4.4832C15.1212 4.94464 15.113 5.42213 15 5.88Z'
const THUMB_DOWN =
  'M17 14V2M9.00004 18.12L10 14H4.17004C3.85955 14 3.55333 13.9277 3.27562 13.7889C2.99791 13.65 2.75634 13.4484 2.57004 13.2C2.38375 12.9516 2.25785 12.6633 2.2023 12.3578C2.14676 12.0523 2.16311 11.7381 2.25004 11.44L4.58004 3.44C4.70121 3.02457 4.95385 2.65964 5.30004 2.4C5.64624 2.14036 6.0673 2 6.50004 2H20C20.5305 2 21.0392 2.21071 21.4143 2.58579C21.7893 2.96086 22 3.46957 22 4V12C22 12.5304 21.7893 13.0391 21.4143 13.4142C21.0392 13.7893 20.5305 14 20 14H17.24C16.868 14.0002 16.5033 14.1042 16.1871 14.3003C15.8709 14.4964 15.6156 14.7768 15.45 15.11L12 22C11.5285 21.9942 11.0643 21.8818 10.6422 21.6714C10.2202 21.461 9.85112 21.1579 9.56264 20.7848C9.27416 20.4117 9.07373 19.9782 8.97631 19.5168C8.87889 19.0554 8.887 18.5779 9.00004 18.12Z'

const LockScreenPhone = () => (
  <svg width="78" height="82" viewBox="0 0 78 82" aria-hidden="true">
    <defs>
      <linearGradient id="lu-off-dark" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor={palette.phoneSurface} />
        <stop offset="1" stopColor={palette.phoneScreenEnd} />
      </linearGradient>
    </defs>
    <path
      d="M2 82V14a12 12 0 0 1 12-12h50a12 12 0 0 1 12 12v68"
      fill="url(#lu-off-dark)"
      stroke={palette.phoneBezel}
      strokeWidth="4"
    />
    <text x="39" y="22" fontSize="11" textAnchor="middle" fill={palette.white}>
      9:41
    </text>
    <rect
      x="8"
      y="28"
      width="62"
      height="38"
      rx="6"
      fill={palette.phoneCutout}
      opacity="0.55"
    />
    <rect
      x="13"
      y="33"
      width="9"
      height="9"
      rx="2"
      fill={palette.mockBrandTile}
    />
    <text
      x="65"
      y="40"
      fontSize="5.5"
      textAnchor="end"
      fill={palette.white}
      opacity="0.85"
    >
      ETA 9:41pm
    </text>
    <text x="13" y="52" fontSize="7" fontWeight="900" fill={palette.white}>
      Order placed
    </text>
    <line
      x1="15"
      y1="59"
      x2="63"
      y2="59"
      stroke={palette.white}
      strokeOpacity="0.35"
      strokeWidth="1.5"
    />
    <circle cx="15" cy="59" r="2" fill={palette.white} />
    <circle cx="39" cy="59" r="2" fill={palette.white} fillOpacity="0.35" />
    <circle cx="63" cy="59" r="2" fill={palette.white} fillOpacity="0.35" />
  </svg>
)

const InAppPhone = () => (
  <svg width="94" height="82" viewBox="0 0 94 82" aria-hidden="true">
    <path
      d="M2 82V14a12 12 0 0 1 12-12h66a12 12 0 0 1 12 12v68"
      fill={palette.white}
      stroke={palette.phoneBezel}
      strokeWidth="4"
    />
    <text
      x="47"
      y="17"
      fontSize="7"
      fontWeight="700"
      textAnchor="middle"
      fill={palette.grey90}
    >
      Your Order
    </text>
    <rect x="6" y="21" width="82" height="12" fill={palette.grey10} />
    <text
      x="47"
      y="46"
      fontSize="7"
      fontWeight="900"
      textAnchor="middle"
      fill={palette.grey90}
    >
      Success! Your order was
    </text>
    <text
      x="47"
      y="55"
      fontSize="7"
      fontWeight="900"
      textAnchor="middle"
      fill={palette.grey90}
    >
      submitted
    </text>
    <rect
      x="11"
      y="59"
      width="72"
      height="19"
      rx="3"
      fill={palette.mockAlertWash}
    />
    <text
      x="47"
      y="67"
      fontSize="5"
      fontWeight="700"
      textAnchor="middle"
      fill={palette.mockAlertText}
    >
      ESTIMATED PICKUP
    </text>
    <text
      x="47"
      y="74"
      fontSize="5"
      fontWeight="700"
      textAnchor="middle"
      fill={palette.mockAlertText}
    >
      {PICKUP_WINDOW}
    </text>
  </svg>
)

const FeedbackPhone = () => (
  <svg width="78" height="52" viewBox="0 0 78 52" aria-hidden="true">
    <path
      d="M2 52V14a12 12 0 0 1 12-12h50a12 12 0 0 1 12 12v38"
      fill={palette.white}
      stroke={palette.phoneBezel}
      strokeWidth="4"
    />
    <text
      x="39"
      y="17"
      fontSize="6"
      fontWeight="900"
      textAnchor="middle"
      fill={palette.grey90}
    >
      How was your order?
    </text>
    <rect
      x="9.5"
      y="23"
      width="28"
      height="14"
      rx="3"
      fill={palette.white}
      stroke={palette.grey30}
    />
    <rect
      x="40.5"
      y="23"
      width="28"
      height="14"
      rx="3"
      fill={palette.white}
      stroke={palette.grey30}
    />
    <svg x="18.5" y="25" width="10" height="10" viewBox="0 0 24 24" fill="none">
      <path
        d={THUMB_UP}
        stroke={palette.mockSuccess}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <svg x="49.5" y="25" width="10" height="10" viewBox="0 0 24 24" fill="none">
      <path
        d={THUMB_DOWN}
        stroke={palette.mockAlert}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </svg>
)

const PHONES: Record<TurnOffIllustrationKind, React.ComponentType> = {
  lock_screen: LockScreenPhone,
  in_app: InAppPhone,
  feedback: FeedbackPhone,
}

export interface TurnOffIllustrationProps {
  kind: TurnOffIllustrationKind
}

const TurnOffIllustration = ({ kind }: TurnOffIllustrationProps) => {
  const [css] = useStyletron()
  const Phone = PHONES[kind]

  return (
    <div
      data-testid={`lu-turn-off-illustration-${kind}`}
      aria-hidden="true"
      className={css({
        position: 'relative',
        height: ILLUSTRATION_HEIGHT,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundImage: `linear-gradient(158deg, ${palette.mockWashStart}, ${palette.mockWashEnd})`,
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        borderBottomLeftRadius: '8px',
      })}
    >
      <span
        data-testid="lu-turn-off-badge"
        className={css({
          position: 'absolute',
          top: '8px',
          right: '8px',
          width: BADGE_SIZE,
          height: BADGE_SIZE,
          borderTopLeftRadius: '50%',
          borderTopRightRadius: '50%',
          borderBottomRightRadius: '50%',
          borderBottomLeftRadius: '50%',
          backgroundColor: palette.grey90,
          color: palette.white,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
        })}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
        >
          <path d="M18 6 6 18" />
          <path d="M6 6l12 12" />
        </svg>
      </span>
      <span
        className={css({
          display: 'flex',
          ...(kind === 'in_app'
            ? {}
            : { filter: 'grayscale(1)', opacity: 0.6 }),
        })}
      >
        <Phone />
      </span>
    </div>
  )
}

export default TurnOffIllustration
